// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SZASp","card":"styles_card__ztrQU","col":"styles_col__JUb3h"};